<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'
import { useSidebar } from './useSidebar'

interface Props {
  class?: HTMLAttributes['class']
  side?: 'left' | 'right'
}

withDefaults(defineProps<Props>(), {
  side: 'left',
})

const { open, setOpen } = useSidebar()
</script>

<template>
  <div
    :class="
      cn(
        'relative hidden md:flex md:flex-col md:border-r md:bg-background md:text-foreground group/sidebar',
        {
          'w-16': !open,
          'w-64': open,
          'transition-all duration-300': true,
        },
        $props.class
      )
    "
    :data-collapsible="!open ? 'icon' : 'default'"
  >
    <slot />
  </div>

  <!-- Mobile Sidebar -->
  <div v-if="open" class="absolute inset-0 z-40 md:hidden bg-black/80" @click="setOpen(false)" />
  <div
    :class="
      cn('absolute inset-y-0 left-0 z-50 w-64 border-r bg-background text-foreground md:hidden', {
        'translate-x-0': open,
        '-translate-x-full': !open,
        'transition-transform duration-300': true,
      })
    "
  >
    <slot />
  </div>
</template>
